// extracted by mini-css-extract-plugin
export default {"wrapper":"MenuTitleComponent_wrapper__QcY6F","logoImage":"MenuTitleComponent_logoImage__tT18B"};